module.exports = __webpack_public_path__ + "img/Left_Sphere.8c91c290.png";